import styled from 'styled-components';

export const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.palette.gray15};
  font-size: 14px;
  font-weight: 500;
  padding-top: 1px;
`;

export const CheckBox = styled.div`
  height: 20px;
  width: 20px;
  align-self: center;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.gray500};

  &.checked {
    background-color: ${({ theme }) => theme.palette.brand400};
  }
`;
